export enum TextInputAlign {
	Left = 'left',
	Center = 'center',
	Right = 'right',
}

export interface ITextInput {
	height: number;
	fontSize: number;
	textAlign?: TextInputAlign;
	padding?: string;
	active?: boolean;
	error?: boolean;
	activeBgColor?: string;
	activeTextColor?: string;
	placeholderOpacity?: number;
}
